import { Navigate, Outlet } from "react-router-dom";

function MFARoutes() {
  const mfaData = sessionStorage.getItem("mfa_user_sub") || null;

  if (!mfaData) return <Navigate to="/user/login" />;

  return <Outlet />;
}

export default MFARoutes;
